module.exports = __webpack_public_path__ + "static/NeueMontreal-Medium-da55e19df29c8a7047a04c61eac5d3b3.woff2";